import { FLMI2Person } from '../model/flmi2.model';
import { SortDirection } from '../model/sort-direction.model';
export function sortByFLTotalDirectReport(
    sortDirection: SortDirection = SortDirection.ASC,
) {
    // sortDirection: true = asc score, desc totalopps, asc name;
    //                false = desc score, asc totalopps, desc name
    return (a: FLMI2Person, b: FLMI2Person) => {
        let retVal = 0;

        // retVal = byFLMi2(a, b, sortDirection);
        // if (retVal !== null) {
        //     return retVal;
        // }

        retVal = byTotalDirectReport(a, b, sortDirection);
        if (retVal !== null) {
            return retVal;
        }

        if (retVal !== null) {
            return retVal;
        }

        return 0;
    };
}
const byTotalDirectReport = (
    a: FLMI2Person,
    b: FLMI2Person,
    sortDirection: SortDirection,
): number => {
    const s1 = a.totalDirectReports;
    const s2 = b.totalDirectReports;

    let retVal: number | null = null;

    if (s1 === undefined) return -1;
    if (s2 === undefined) return -1;

    if (s1 === null && s2 != null) return -1;
    else if (s2 === null && s1 != null) return 1;
    else if (s1 < s2) {
        retVal = 1;
    } else if (s1 > s2) {
        retVal = -1;
    }

    return retVal == null
        ? null
        : sortDirection === SortDirection.ASC
        ? retVal * -1
        : retVal;
};
